import TailwindIndicator from './TailwindIndicator';

export default TailwindIndicator;
